import React from "react";

const SectionHeader = ({
  title,
  description,
  TitleColor = "#E98362",
  DescriptionColor = "#ABABAB",
  textAlign = "center",
}) => {
  return (
    <div
      className={`relative z-10 max-w-3xl text-${textAlign} mb-4`}
      data-aos=""
    >
      <h2
        className="text-2xl md:text-3xl font-semibold leading-tight"
        style={{ color: TitleColor }}
      >
        {title}
      </h2>
      <p className="text-sm mt-2" style={{ color: DescriptionColor }}>
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;
